import React, { ReactElement, useEffect } from 'react';
import InputEmail from 'src/components/InputEmail';
import { EMAIL_REGEX } from 'src/constants';
import Button from 'src/components/PrimaryButton';
interface EmailProps {
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  otpRequest: boolean;
  onSubmit: Function;
  isBtnEnable: boolean;
  setIsBtnEnable: Function;
}

const EmailLogin = ({
  email,
  setEmail,
  otpRequest,
  onSubmit,
  isBtnEnable,
  setIsBtnEnable,
}: EmailProps): ReactElement => {
  const message = 'Enter email';

  const buttonName = otpRequest ? 'Loading...' : 'Proceed';
  function handleChange(e?: Record<string, any>): void {
    setEmail(e?.target.value);
  }
  useEffect(() => {
    setIsBtnEnable(() => {
      return email.match(EMAIL_REGEX) ? true : false;
    });
  }, [email]);

  return (
    <>
      <div>
        <h1 className="font-bold text-xl mt-20">{message}</h1>
      </div>
      <form className="mt-8">
        <div className="flex justify-center">
          <InputEmail handleChange={handleChange} email={email} />
        </div>
        <Button
          buttonName={buttonName}
          onSubmit={(e): void => onSubmit(e)}
          isBtnEnable={isBtnEnable}
        />
      </form>
    </>
  );
};

export default EmailLogin;
